import Monitor from "../firmaContrato/monitor/Monitor";

const Index = () =>  <div>{localStorage.getItem("id_perfil") === "6" && <Monitor />}</div>;

export default Index;
